import { handleErrors } from './ErrorActions';
import * as productHierarchyApi from '../api/product-hierarchy';
import { getSearchOptions, updateHierarchyById } from '../utils/productHierarchyUtils';

export const FETCH_HIERARCHY = 'FETCH_HIERARCHY';
export const FETCH_HIERARCHY_SUCCESS = 'FETCH_HIERARCHY_SUCCESS';
export const FETCH_HIERARCHY_FAILURE = 'FETCH_HIERARCHY_FAILURE';

export const FETCH_PRODUCT_CHILDREN = 'FETCH_PRODUCT_CHILDREN';
export const FETCH_PRODUCT_CHILDREN_SUCCESS = 'FETCH_PRODUCT_CHILDREN_SUCCESS';
export const FETCH_PRODUCT_CHILDREN_FAILURE = 'FETCH_PRODUCT_CHILDREN_FAILURE';

export const ADD_HIERARCHY_CHILD = 'ADD_HIERARCHY_CHILD';
export const ADD_EXPANDED_NODES = 'ADD_EXPANDED_NODES';
export const CLEAR_HIERARCHY = 'CLEAR_HIERARCHY';
export const CLOSE_EXPANDED_NODE = 'CLOSE_EXPANDED_NODE';

const fetchProductHierarchySuccess = (hierarchy) => ({
  type: FETCH_HIERARCHY_SUCCESS,
  payload: { hierarchy },
});

const fetchProductChildren = ({ itemId }) => ({
  type: FETCH_PRODUCT_CHILDREN,
  payload: { itemId },
});

const fetchProductChildrenSuccess = ({ updatedHierarchy, itemId, currentPageIndex }) => ({
  type: FETCH_PRODUCT_CHILDREN_SUCCESS,
  payload: { updatedHierarchy, itemId, currentPageIndex },
});

const fetchProductChildrenFailure = (itemId) => ({
  type: FETCH_PRODUCT_CHILDREN_FAILURE,
  payload: { itemId },
});

export const addExpandedNodes = (nodes) => ({
  type: ADD_EXPANDED_NODES,
  payload: { nodes },
});

export const closeExpandedNode = (id) => ({
  type: CLOSE_EXPANDED_NODE,
  payload: { nodeId: id },
});

export const clearHierarchy = () => ({
  type: CLEAR_HIERARCHY,
});

export const fetchProductHierarchy = ({ itmId, entityName }) => async (dispatch) => {
  dispatch({
    type: FETCH_HIERARCHY,
  });

  try {
    const apiData = await productHierarchyApi.getProductHierarchy({ itmId, entityName });

    if (apiData.hasError) {
      dispatch({ type: FETCH_HIERARCHY_FAILURE });
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(fetchProductHierarchySuccess(apiData.productHierarchy));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchProductHierarchy() failed: ${JSON.stringify(error)}`);
    dispatch({ type: FETCH_HIERARCHY_FAILURE });
    dispatch(handleErrors(error));
  }
};

export const fetchProductChildrenByItemId = ({ itemId, entityName, pageSize = 50 }) => async (
  dispatch,
  getState
) => {
  const { hierarchy, paginationList } = getState().productHierarchy;

  const currentPageIndex = paginationList[itemId]?.currentPageIndex ?? 0;

  dispatch(fetchProductChildren({ itemId }));

  try {
    const apiData = await productHierarchyApi.getHierarchyChildren({
      itmId: itemId,
      entityName,
      currentPageIndex,
      pageSize,
    });

    if (apiData.hasError) {
      dispatch(fetchProductChildrenFailure(itemId));
      dispatch(handleErrors(apiData.errors));
      return;
    }

    const updatedHierarchy = updateHierarchyById({
      hierarchy,
      itemId,
      newChildren: apiData.productHierarchyChildren,
    });

    dispatch(fetchProductChildrenSuccess({ updatedHierarchy, itemId, currentPageIndex }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchProductChildrenByItemId() failed: ${JSON.stringify(error)}`);
    dispatch(fetchProductChildrenFailure(itemId));
    dispatch(handleErrors(error));
  }
};

export const fetchHierarchySearchResults = ({
  itemId,
  entityName,
  pageSize = 0,
  filter = '',
}) => async (dispatch) => {
  try {
    const apiData = await productHierarchyApi.getHierarchyChildren({
      itmId: itemId,
      entityName,
      pageSize,
      filter,
    });

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return [];
    }

    return getSearchOptions(apiData.productHierarchyChildren);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchHierarchySearchResults() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
    return [];
  }
};

export const addHierarchyChild = ({ itemId, newChild }) => (dispatch, getState) => {
  try {
    const { hierarchy } = getState().productHierarchy;

    const updatedHierarchy = updateHierarchyById({
      hierarchy,
      itemId,
      newChildren: [newChild],
    });

    dispatch({ type: ADD_HIERARCHY_CHILD, payload: { updatedHierarchy } });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`addHierarchyChild() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};
